import { css } from "@emotion/react";

export const SocContainer = css`
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 40px 20px 0 20px;
`;

export const Title = css`
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 500;
    color: #111111;
`;

export const SocContent = css`
    width: 100%;
    display: flex;
    gap: 8px;
    flex-direction: row;
    align-items: center;
    padding: 28px 0px;
    border-bottom: 1px solid #e0e0e0;
    flex-wrap: wrap;
    
    & > * {
        flex-shrink: 0;
    }
`;

export const Select = css`
    width: 100px;
    height: 40px;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 30px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    color: #111111;
`;

export const RoundButton = css`
    width: 70px;
    height: 40px;
    background-color: #1428A0;
    color: #ffffff;
    border-radius: 30px;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    border: none;

    &.fill {
        border: none;
        background-color: #1428A0;
        color: #ffffff;
    }
`;

export const Font = css`
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    display: flex;
    align-items: center;
`;